import { fetchWithAuth } from './fetchWithAuth';

export async function getUserHistory(userId) {
  if (!userId) throw new Error('Missing userId');
  const res = await fetchWithAuth(`/api/history/${userId}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  const data = await res.json();
  return data;
}
